import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";
import TablePage from "@beeldit/core/pages/TablePage";
import ReadOnlyCalendar from "../components/ReadOnlyCalendar";

function SessionsCalendarPage(props: {
  filters?: any;
  formDefaultValues?: any;
}) {
  const { filters, formDefaultValues } = props;

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: formDefaultValues || null, // Valores por defecto del formulario
    filters: filters || null, // Filtros para la tabla
    formFilterValues: null,
  };

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <>
              <ReadOnlyCalendar />
            </>
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default SessionsCalendarPage;
